import { useAppSelector } from '@stores/slices/hooks';
import { selectUsername } from '@stores/slices/userSlice';
import { useDeviceRenameBetterGuardClient } from '@hooks/useDeviceRenameBetterGuardClient';

export enum Resource {
  Device = 'Device',
  DeviceLink = 'DeviceLink',
  Site = 'Site',
}

export enum ResourceAction {
  Read = 'Read',
  Write = 'Write',
}

export function useHasResourcePermission(
  resourceType: Resource,
  action: ResourceAction
) {
  const username = useAppSelector(selectUsername);
  const betterGuardClient = useDeviceRenameBetterGuardClient();

  if (!username || !betterGuardClient) {
    //Login process not finished, no permissions to do anything
    return { hasPermission: false };
  }

  return { hasPermission: betterGuardClient.canAccess(resourceType, action) };
}
